export * from './fetchPageREST';
export * from './adapter';
